var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondSuiAdaptiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 134,
    viewBox: "0 0 129 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sui"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_18533)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5282,
    cy: 26.9927,
    rx: 24.5282,
    ry: 26.9927,
    transform: "matrix(0.96438 -0.264521 0.221031 0.975267 35 46.9844)",
    fill: "#4DA2FF",
    fillOpacity: 0.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_18533)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5282,
    cy: 26.9927,
    rx: 24.5282,
    ry: 26.9927,
    transform: "matrix(0.96438 -0.264521 0.221031 0.975267 35 46.9844)",
    fill: "#4DA2FF",
    fillOpacity: 0.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    filter: "url(#filter2_f_1877_18533)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5282,
    cy: 26.9927,
    rx: 24.5282,
    ry: 26.9927,
    transform: "matrix(0.96438 -0.264521 0.221031 0.975267 35 46.9844)",
    fill: "#4DA2FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.8914 49.6382C69.1719 51.4755 71.4219 53.3598 73.7411 55.1407C77.2113 57.8044 79.484 61.3115 80.1195 65.865C80.9911 72.0965 79.1387 77.3966 74.5145 81.3881C67.3839 87.5441 57.1577 85.8429 52.2513 77.7055C49.391 72.954 48.9685 67.7648 51.1435 62.5173C53.4322 56.9986 55.9599 51.5884 58.3804 46.1288C58.5939 45.6469 58.7584 45.1382 59.0004 44.676C59.2947 44.1115 59.6954 43.9557 60.2266 44.3909C60.8339 44.8895 61.473 45.3465 62.0959 45.8225C63.6291 47.1853 65.2298 48.459 66.8914 49.6382ZM55.0111 75.0832L55.1569 75.3181C55.1738 75.404 55.277 75.5356 55.3132 75.614C58.801 81.4376 66.9539 82.7839 72.0575 78.3934C72.4036 78.095 72.5494 77.8297 72.4552 77.346C72.0755 75.3978 71.2274 73.7686 69.7985 72.4929C68.0675 70.952 66.0094 70.1641 63.8745 69.5072C60.7858 68.5494 58.0609 66.9934 56.2347 64.0327C55.8505 63.4051 55.5245 62.7468 55.1204 62.0092C53.8327 64.3782 53.189 66.8014 53.3644 69.4086C53.5072 71.4622 53.9763 73.168 55.0111 75.0832ZM75.4865 73.8391C75.6837 73.4295 75.8009 73.227 75.8823 73.0104C76.8321 70.4243 76.9652 67.5871 76.261 64.9369C75.5567 62.2866 74.0543 59.9708 71.9857 58.3471C69.6881 56.5401 67.4043 54.7036 65.1164 52.8793C63.9705 51.9634 62.8257 51.0472 61.6819 50.1307C61.1703 49.7212 60.6249 49.5795 60.29 50.3054C59.5021 52.0095 58.6249 53.6831 58.404 55.6165C58.0361 58.8327 58.6601 61.6394 61.1582 63.6791C62.4896 64.7671 64.0401 65.368 65.6436 65.8463C68.0799 66.5762 70.3484 67.6711 72.3237 69.3814C73.6622 70.5536 74.6684 72.0093 75.4865 73.8391Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_18533",
    x: 0.918751,
    y: 0.403126,
    width: 127.405,
    height: 132.838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18533"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_18533",
    x: 0.918751,
    y: 0.403126,
    width: 127.405,
    height: 132.838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18533"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1877_18533",
    x: 0.918751,
    y: 0.403126,
    width: 127.405,
    height: 132.838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18533"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondSuiAdaptiveIcon);
export default __webpack_public_path__ + "static/media/SecondSuiAdaptiveIcon.4646b4cd69da6bf494dbf76c8143afba.svg";
export { ForwardRef as ReactComponent };